<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Reset your password
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <p>Enter your new password below.</p>
                <notifications />
                <form
                  ref="form"
                  @submit.prevent="reset"
                >
                  <input
                    v-model="token"
                    type="hidden"
                  >
                  <div class="form-group row">
                    <label
                      for="email"
                      class="col-md-4 col-form-label text-md-right"
                    >E-Mail Address</label>

                    <div class="col-md-6">
                      <input
                        id="email"
                        v-model="email"
                        type="email"
                        class="form-control"
                        required
                        autofocus
                      >
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      for="password"
                      class="col-md-4 col-form-label text-md-right"
                    >Password</label>

                    <div class="col-md-6">
                      <input
                        id="password"
                        v-model="password"
                        type="password"
                        class="form-control"
                        required
                      >
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      for="password-confirm"
                      class="col-md-4 col-form-label text-md-right"
                    >Confirm Password</label>

                    <div class="col-md-6">
                      <input
                        id="password-confirm"
                        v-model="password_confirmation"
                        type="password"
                        class="form-control"
                        required
                      >
                    </div>
                  </div>
                  <div class="form-group row mb-0">
                    <div class="col-md-6 offset-md-4">
                      <button
                        type="submit"
                        class="btn btn-primary"
                      >
                        Reset Password
                      </button>

                      <router-link
                        class="btn btn-link"
                        :to="{name: 'forgot-password'}"
                      >
                        Send a new reset password email
                      </router-link>                                
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Passwords from '../services/passwords.js';

export default {
  data () {
    return {
      email: null,
      password: null,
      password_confirmation: null,
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  methods: {
    reset() {
      this.errors = null;
                
      Passwords.reset({token: this.token, email: this.email, password: this.password, password_confirmation: this.password_confirmation}).then(res => {
        this.$router.push({name: 'login'});
        this.$store.dispatch('notifications/setSuccess', 'Your password has been reset');
      }).catch((err) => {
        this.$store.dispatch('notifications/setError', err.response.data.message || 'There was an error resetting your password.');
        this.$store.dispatch('notifications/setErrorBag', err.response.data.errors);
      });
    }
  }
}
</script>
